module.exports = __webpack_public_path__ + "img/halal.2823b05a.svg";